module.exports = __webpack_public_path__ + "static/media/spinner.e3f9872f60.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/spinner.svg
// module id = 6196
// module chunks = 0